module.exports = __webpack_public_path__ + "img/成都舒百颜.1ff80e9.png";